import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useFirmwaresStore = defineStore('firmwares', () => {

    const configStore               = useConfigStore()
    const requestsStore             = useRequestsStore()
    const tokenStore                = useTokenStore()

    const firmwares                 = ref({})
    const firmwaresProcess          = ref(false)
    const firmwaresMsg              = ref({})

    const firmware                  = ref({})
    const firmwareProcess           = ref(false)
    const firmwareMsg               = ref({})

    const firmwaresCreateProcess    = ref(false)
    const firmwaresCreateMsg        = ref({})

    const firmwareUpdateProcess    = ref(false)
    const firmwareUpdateMsg        = ref({})

    const firmwareDeleteProcess    = ref(false)
    const firmwareDeleteMsg        = ref({})

    /**
     * Загружает новый файл прошивки
     */
    async function createFirmwares(payload) {

        firmwaresCreateProcess.value = true
        const token = tokenStore.access
        let result = {}

        if(token) { 

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/multi_car_firmware/upload`, 
                method: 'POST', 
                token,
                type: 'file',
                data: payload
            })

            if(!request.error) {
                result = request
                firmwaresCreateMsg.value = { success: true, text: 'FIRMWARES_CREATE_SUCCESS' }
            } else {
                firmwaresCreateMsg.value = { success: false, text: request.error }
            }

        } else {
            firmwaresCreateMsg.value = { success: false, text: 'EToken' }
        }

        firmwaresCreateProcess.value = false
        return result
    }

    /**
     * Получает все доступные загруженные файлы прошивок
     */
    async function readFirmwares(payload) {

        firmwaresProcess.value = true
        const token = tokenStore.access

        if(token) { 

            let params = ''

            if(payload) {
                for( let param in payload) {
                    if(Array.isArray(payload[param])) {
                        payload[param].map( el => {
                            params.length ?
                                params += '&' + param + '=' + el :
                                params = '?' + param + '=' + el
                        })
                    } else {
                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/multi_car_firmware${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                firmwares.value = request
                firmwaresMsg.value = { success: true }
            } else {
                firmwares.value = {}
                firmwaresMsg.value = { success: false, text: request.error }
            }

        } else {
            firmwaresMsg.value = { success: false, text: 'EToken' }
        }

        firmwaresProcess.value = false
        return firmwares.value
    }

    /**
     * Получает прошивку с указанным именем
     */
    async function readFirmware(payload) {

        firmwareProcess.value = true
        const token = tokenStore.access

        if(token) { 

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/multi_car_firmware/${payload}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                firmware.value = request
                firmwareMsg.value = { success: true }
            } else {
                firmware.value = {}
                firmwareMsg.value = { success: false, text: request.error }
            }

        } else {
            firmwareMsg.value = { success: false, text: 'EToken' }
        }

        firmwareProcess.value = false
        return firmware.value
    }

    /**
     * Обновляет существующую прошивку (запись с информацией о прошивке)
     */
    async function updateFirmwares(payload) {

        firmwareUpdateProcess.value = true
        const token = tokenStore.access
        let result = {}

        if(token) { 

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/multi_car_firmware`, 
                method: 'POST', 
                token, 
                data: payload
            })

            if(!request.error) {
                result = request
                firmwareUpdateMsg.value = { success: true, text: 'FIRMWARES_UPDATE_SUCCESS' }
            } else {
                firmwareUpdateMsg.value = { success: false, text: request.error }
            }

        } else {
            firmwareUpdateMsg.value = { success: false, text: 'EToken' }
        }

        firmwareUpdateProcess.value = false
        return result
    }

    /**
     * Удаляет прошивки
     * 
     * @param {String} payload - UUID удалённой прошивки
     */
    async function deleteFirmwares(payload) {

        firmwareDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/multi_car_firmware/${payload}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                firmwareDeleteMsg.value = { success: true, text: 'FIRMWARES_DELETE_SUCCESS' }
            } else {
                firmwareDeleteMsg.value = { success: false }
                firmwareDeleteMsg.value.text = request.error
            }

        } else {
            firmwareDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        firmwareDeleteProcess.value = false
    }

    const setFirmwares          = data => firmwares.value           = data
    const setFirmwaresCreateMsg = data => firmwaresCreateMsg.value  = data
    const setFirmwareUpdateMsg = data => firmwareUpdateMsg.value  = data
    const setFirmwareDeleteMsg = data => firmwareDeleteMsg.value  = data

    return {

        firmwares, 
        firmwaresProcess, 
        firmwaresMsg, 
        firmware, 
        firmwareProcess, 
        firmwareMsg, 
        firmwaresCreateProcess, 
        firmwaresCreateMsg, 
        firmwareUpdateProcess, 
        firmwareUpdateMsg, 
        firmwareDeleteProcess, 
        firmwareDeleteMsg, 
        createFirmwares, 
        readFirmwares, 
        readFirmware, 
        updateFirmwares, 
        deleteFirmwares, 
        setFirmwares, 
        setFirmwaresCreateMsg, 
        setFirmwareUpdateMsg, 
        setFirmwareDeleteMsg
    }
})
